import { useCreateAllVideosTree } from "../hooks/useCreateAllVideosTree";
import TreeViewComponent from "../components/TreeViewComponent";
import { useFilterTreeData } from "../hooks/useFilterTreeData";

export default function AllVideosList({ onContextMenuClick, searchString }) {

    const { myArray: treeData } = useCreateAllVideosTree()
    const filteredTreeData  = useFilterTreeData(treeData, searchString)

    
    // var filteredTreeData = []
    // if (searchString !== '') {
    //     var tmpData = treeData && treeData.filter(t => t.text.toUpperCase().startsWith(searchString))
    //     //remove parents
    //     tmpData = tmpData.filter(t => t.droppable === false)
    //     tmpData.map(t => {
    //         const tNode = {
    //             parent: 0,
    //             text: t.text,
    //             id: t.id,
    //             droppable: t.droppable
    //         }
    //         filteredTreeData.push(tNode)
    //     })
    // } else {
    //     filteredTreeData = treeData
    // }

    return (
        <div>
            <TreeViewComponent treeData={filteredTreeData} onContextMenuClick={onContextMenuClick} />
        </div>
    )
}